import { runAfterLoad, useGsap } from './gsap-lazy';

const hamburger = document.querySelector('.hamburger');
const navMenu = document.querySelector('.nav-menu');
const navBar = document.querySelector('.navbar');

if (hamburger && navMenu && navBar) {
  hamburger.addEventListener('click', () => {
    hamburger.classList.toggle('active');
    navMenu.classList.toggle('active');
    navBar.classList.toggle('active');
  });
}

document.querySelectorAll('.nav-link').forEach((link) => {
  link.addEventListener('click', () => {
    if (!hamburger || !navMenu || !navBar) return;
    hamburger.classList.remove('active');
    navMenu.classList.remove('active');
    navBar.classList.remove('active');
  });
});

function initFormUi() {
  if (!document.querySelector('#Kontakt')) return;

  const inputs = document.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"], select, textarea');
  inputs.forEach((input) => {
    input.addEventListener('focus', () => {
      const label = input.previousElementSibling;
      label.style.transform = 'translate(-1.5px, -28px)';
      label.style.color = '#FFFFFF';
      label.style.fontSize = '0.875rem';
    });

    input.addEventListener('blur', () => {
      if (input.value) return;
      const label = input.previousElementSibling;
      label.style.transform = 'translate(10px, 7px)';
      label.style.color = '#FFFFFF';
      label.style.fontSize = '1.125rem';
    });

    const label = input.previousElementSibling;
    if (input.value) {
      label.style.transform = 'translate(-1.5px, -28px)';
      label.style.color = '#FFFFFF';
      label.style.fontSize = '0.875rem';
    }
  });

  const sel = document.getElementById('topic');
  const msg = document.getElementById('message');

  function setMessage(pkg) {
    if (!msg) return;
    const text = `Ich habe Interesse an einem Projekt aehnlich dem ${pkg} Paket.`;
    msg.value = msg.value.trim() ? `${msg.value.trim()}\n\n${text}` : text;
    msg.focus();
  }

  document.querySelectorAll('[data-topic]').forEach((el) => {
    el.addEventListener('click', () => {
      const pkg = el.dataset.topic;
      if (sel) {
        sel.value = 'Neue Website';
        sel.dispatchEvent(new Event('change'));
        sel.focus();
      }
      setMessage(pkg);
    });
  });
}

function initAccordion() {
  const accordion = document.querySelector('.accordion');
  if (!accordion) return;

  accordion.addEventListener('click', (e) => {
    const activePanel = e.target.closest('.accordion-panel');
    if (!activePanel) return;

    const activeButton = activePanel.querySelector('button');
    const activeContent = activePanel.querySelector('.accordion-content');
    const isOpened = activeButton.getAttribute('aria-expanded') === 'true';

    activeButton.setAttribute('aria-expanded', String(!isOpened));
    activeContent.setAttribute('aria-hidden', String(isOpened));
  });
}

function initGsapAnimations(gsap) {
  const cards = gsap.utils.toArray('.card');
  cards.forEach((card, index) => {
    if (index >= cards.length - 1) return;
    const nextCard = cards[index + 1];
    gsap.to(card, {
      opacity: 0,
      ease: 'none',
      scrollTrigger: {
        trigger: nextCard,
        start: 'bottom 55%',
        end: 'bottom 40%',
        scrub: true,
      },
    });
  });

  document.querySelectorAll('.pop-up').forEach((element) => {
    gsap.fromTo(
      element,
      { opacity: 0, y: 50 },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: element,
          start: 'top 110%',
          toggleActions: 'play reverse play reverse',
        },
      }
    );
  });

  document.querySelectorAll('.text-pop-up').forEach((element) => {
    gsap.fromTo(
      element,
      { opacity: 0, y: 50 },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: element,
          start: 'top 110%',
          toggleActions: 'play reverse play reverse',
        },
      }
    );
  });
}

initFormUi();
initAccordion();

function initGsapOnDemand() {
  const firstTarget = document.querySelector('.card, .pop-up, .text-pop-up');
  if (!firstTarget) return;

  let started = false;
  const interactionEvents = ['scroll', 'wheel', 'touchmove', 'pointerdown'];

  const cleanup = () => {
    interactionEvents.forEach((eventName) => {
      window.removeEventListener(eventName, start);
    });
    window.removeEventListener('keydown', start);
  };

  const start = async () => {
    if (started) return;
    started = true;
    cleanup();
    const { gsap } = await useGsap();
    initGsapAnimations(gsap);
  };

  const startPassive = { passive: true, once: true };
  interactionEvents.forEach((eventName) => {
    window.addEventListener(eventName, start, startPassive);
  });
  window.addEventListener('keydown', start, { once: true });
}

runAfterLoad(initGsapOnDemand);
